var _circle, _circle2, _g, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYourLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#FFE4EE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_8832",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#FFE14D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_8832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.944 28.056L30 30C27.262 32.738 22.8035 32.6743 20.1448 29.8592C17.9979 27.586 17.6562 24.1501 19.3134 21.4986L20.9571 18.8687C21.3119 18.301 21.5 17.645 21.5 16.9756C21.5 13.6812 25.5803 12.1431 27.755 14.6177L32.2136 19.6913C34.3431 22.1145 34.2251 25.7749 31.944 28.056Z",
    fill: "#FFE4EE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5001 6.00488C12.096 6.00488 8.50391 9.59695 8.50391 14.001C8.50391 15.7479 9.05745 17.4086 10.1032 18.7987L16.008 26.7539C16.094 26.8768 16.3278 26.9999 16.5001 26.9999C16.6846 26.9999 16.9061 26.8646 16.9922 26.7538C17.0167 26.7169 22.9585 18.7125 23.0077 18.6387C23.02 18.6387 23.02 18.6387 23.02 18.6265C23.9796 17.2733 24.4962 15.674 24.4962 14.001C24.4962 9.59699 20.9042 6.00488 16.5001 6.00488ZM16.5001 18.3067C14.1259 18.3067 12.1945 16.3753 12.1945 14.001C12.1945 11.6268 14.1259 9.69543 16.5001 9.69543C18.8742 9.69543 20.8057 11.6268 20.8057 14.001C20.8057 16.3753 18.8742 18.3067 16.5001 18.3067Z",
    fill: "url(#paint0_linear_39_8832)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6V9.69054C18.8741 9.69054 20.8056 11.6219 20.8056 13.9962C20.8056 16.3704 18.8741 18.3018 16.5 18.3018V26.995C16.6846 26.995 16.9061 26.8597 16.9921 26.7489C17.0166 26.712 22.9584 18.7077 23.0077 18.6338C23.02 18.6338 23.02 18.6338 23.02 18.6216C23.9795 17.2684 24.4961 15.6691 24.4961 13.9962C24.4962 9.59207 20.9041 6 16.5 6Z",
    fill: "url(#paint1_linear_39_8832)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_8832",
    x1: 8.50391,
    y1: 4.71572,
    x2: 27.149,
    y2: 6.91615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF02A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_8832",
    x1: 16.5,
    y1: 4.71083,
    x2: 25.9196,
    y2: 5.26667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF02A7"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourLocationIcon);
export default __webpack_public_path__ + "static/media/YourLocationIcon.9e24a2107845a02860bdab8efa5eac0d.svg";
export { ForwardRef as ReactComponent };